module.exports = __webpack_public_path__ + "img/arrow-down.fa516c92.svg";